export interface TestingImportPreviewContext {
    kind: string
    value: string
}

export interface TestingImportPreviewRow {
    id: number
    last_name: string
    first_name: string
    mrn: string
    patient_id: number
    patient_match_status: string
    dob: string
    dos: string
    cpt: string
    raw_activity: string
    modifiers: string[]
    units: number
    diagnosis: string
    raw_facility: string
    raw_provider: string
    facility_id: number
    provider_id: number
    filtered: boolean
}

export interface TestingImportPreviewSourceItem {
    kind: string
    raw_value: string
    row_count: number
    cpt: string
    facility_id: number
    provider_id: number
    filtered: boolean
}

export interface TestingImportPreview {
    filename: string
    document_kind: string
    source_context: TestingImportPreviewContext
    detected_facility_id: number
    detected_provider_id: number
    rows: TestingImportPreviewRow[]
    source_items: TestingImportPreviewSourceItem[]
}

export interface ChargeImportOptions {
    disable_auto_77427: boolean
    disable_auto_igrt: boolean
    clear_77427_77336_modifiers: boolean
}

export interface ConfirmTestingImportRequest {
    filename: string
    document_kind: string
    source_context: TestingImportPreviewContext
    rows: TestingImportPreviewRow[]
    source_items: TestingImportPreviewSourceItem[]
    save_mappings: boolean
    save_filters: boolean
    options: ChargeImportOptions
}

export async function uploadTestingImportPreview(endpoint: string, file: File): Promise<TestingImportPreview> {
    const formData = new FormData()
    formData.append("myFile", file, file.name)

    const resp = await fetch(endpoint, {
        method: "POST",
        body: formData,
    })
    const json = await resp.json()

    if (!resp.ok) {
        throw new Error("error" in json ? json.error : "something went wrong")
    }

    return json
}

export async function confirmTestingImport(req: ConfirmTestingImportRequest): Promise<{ import_id: number, message: string }> {
    const resp = await fetch("/v2/imports/confirm-testing-import", {
        method: "POST",
        body: JSON.stringify(req),
    })
    const json = await resp.json()

    if (!resp.ok) {
        throw new Error("error" in json ? json.error : "something went wrong")
    }

    return json
}
